const EXCEL_THUMBNAIL_MAX_CELL_LENGTH = 12;

export function sanitizeExcelThumbnailCellValue(cellValue: unknown): string {
  return String(cellValue)
    .replace(/[<>]/g, '')
    .replace(/javascript:/gi, '')
    .replace(/on\w+=/gi, '');
}

export function truncateExcelThumbnailCellValue(
  value: string,
  maxLength = EXCEL_THUMBNAIL_MAX_CELL_LENGTH
): string {
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.substring(0, maxLength - 2)}..`;
}
